import Button from '@marpla/ui/components/Button';
import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { type FC, useEffect, useState } from 'react';

import $ from './AccountPromoModal.module.scss';

const ACCOUNT_PROMO_LINK = 'https://marpla.website/marpla_prolong7d';
const ACCOUNT_PROMO_MODAL_CLOSED_KEY = 'accountPromoModalClosed';

export const AccountPromoModal: FC<AccountPromoModalProps> = ({ newAccountPromoActivated }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isClosed = window.localStorage.getItem(ACCOUNT_PROMO_MODAL_CLOSED_KEY) === 'true';

    setIsOpen(newAccountPromoActivated && !isClosed);
  }, [newAccountPromoActivated]);

  const closeModal = (): void => {
    window.localStorage.setItem(ACCOUNT_PROMO_MODAL_CLOSED_KEY, 'true');
    setIsOpen(false);
  };

  const openPromoRequest = (): void => {
    window.open(ACCOUNT_PROMO_LINK, '_blank', 'noopener,noreferrer');
    closeModal();
  };

  return (
    <Modal open={newAccountPromoActivated && isOpen} onClose={closeModal}>
      <Box className={$.overlay}>
        <Box className={$.paper}>
          <IconButton className={$.closeButton} onClick={closeModal}>
            <Close fontSize="small" />
          </IconButton>
          <Box className={$.content}>
            <Box className={$.text}>
              Хотите протестировать Marpla дольше? Увеличьте тестовый период с 1 до 7 дней
            </Box>
          </Box>
          <Box className={$.actions}>
            <Button className={$.button} onClick={openPromoRequest}>
              Оставить заявку
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

interface AccountPromoModalProps {
  newAccountPromoActivated: boolean;
}
